import type { CustomIconProps } from '../types';

const DropdownArrowClose = ({ width, height }: CustomIconProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ?? '12'}
        height={height ?? '6'}
        viewBox="0 0 12 6"
        fill="none"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.59216 1.05337C6.41669 0.870547 6.12421 0.862944 5.93922 1.0364L0.779424 5.87472C0.594621 6.04801 0.302487 6.04061 0.126924 5.85821C-0.0486384 5.6758 -0.0411478 5.38745 0.143655 5.21416L5.30345 0.375841C5.85841 -0.144533 6.73584 -0.121728 7.26227 0.426756L11.8735 5.23113C12.0488 5.41378 12.0409 5.70212 11.8559 5.87515C11.6708 6.04819 11.3787 6.0404 11.2034 5.85775L6.59216 1.05337Z"
            fill="#414042"
        />
    </svg>
);

export default DropdownArrowClose;
